import {
  QueryFunction,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { TError, useHandleErrors } from './useHandleErrors';

type TQueryKey = unknown[];

export const useCustomQuery = <TData>(
  queryKey: TQueryKey,
  queryFn: QueryFunction<TData, TQueryKey>,
  options: Omit<
    UseQueryOptions<TData, TError, TData, TQueryKey>,
    'queryFn' | 'queryKey'
  > = {}
) => {
  const { handleErrorsOnError, handleErrorsOnSuccess } = useHandleErrors();
  const { onSuccess, onError } = options;

  return useQuery(queryKey, queryFn, {
    ...options,
    refetchOnWindowFocus: false,
    onError: (error) => {
      handleErrorsOnError(error);
      onError?.(error);
    },
    onSuccess: (data) => {
      handleErrorsOnSuccess(data);
      onSuccess?.(data);
    },
  });
};
